export const initCollapseBlock = function() {
  //   CollapseBlock.Start
  const collapseBox = document.querySelectorAll('[data-add-active-box="parent"]');

  if (collapseBox.length > 0) {
    collapseBox.forEach((el) => {
      const collapseBtn = el.querySelector('[data-add-active-box="btn"]');

      if (collapseBtn) {
        collapseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          el.classList.toggle('is-active');

          if (el.classList.contains('is-active')) {
            const parentChildren = el.querySelectorAll('[data-add-active-box="parent"].is-active');
            if (parentChildren) {
              parentChildren.forEach(elChild => {
                elChild.classList.remove('is-active');
              });
            }
          }
        });
      }
    });
  }

  //   CollapseBlock.End
};
